import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Meta Pixel Code
    const pixelId = '25378909385106188';
    // Initialize fbq
    if (typeof window !== 'undefined') {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Load the pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Initialize and track
      w.fbq('init', pixelId);
      w.fbq('track', 'PageView');
      // Add noscript fallback
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  return null;
}